import { connect } from 'react-redux';
import { requestJoinGroup } from '../redux/groups/actions';
const mapDispatchToProps = {
    requestJoin: requestJoinGroup
};
export default connect(null, mapDispatchToProps);
